var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 d-flex justify-content-center mb-4"},[_vm._t("text")],2)}
var staticRenderFns = []

export { render, staticRenderFns }